// Lumina de la apăsare (mixin-ul glass-press din scss/_mixins.scss): punctul atins,
// relativ la element, în --press-x / --press-y, ca lumina să pornească de acolo.
// Se pune pe onPointerDown; de la tastatură lumina pornește din mijloc.
// target: elementul care se luminează, când nu e cel apăsat (chenarul câmpului).
export function pressPoint(e, target) {
   const el = target || e.currentTarget;
   if (!el || typeof el.getBoundingClientRect !== "function") return;
   const r = el.getBoundingClientRect();
   el.style.setProperty("--press-x", `${e.clientX - r.left}px`);
   el.style.setProperty("--press-y", `${e.clientY - r.top}px`);
}
